// extracted by mini-css-extract-plugin
export var content = "physiotherapie-module--content--Lwtor";
export var orangeTitle = "physiotherapie-module--orangeTitle--uDgXE";
export var subtitle = "physiotherapie-module--subtitle--3IIZb";
export var title = "physiotherapie-module--title--MkhAK";